/**
 * ModuleTerminalConnectivitySpecs
 * @param {Object} data - content data
 * @return {Object} - normalized data
 */
export default (data: any) => {
  if (!data || Object.keys(data).length === 0) {
    return data
  }

  const ethernetValue = data.ethernet?.toLocaleLowerCase()

  if (ethernetValue !== 'yes, with base station required') {
    data.ethernet = ethernetValue === 'yes'
    return data
  }

  data.ethernet = true
  data.ethernetWithBaseStation = true

  return data
}
